module.exports = __webpack_public_path__ + "static/media/chat.c4b8a2b6.svg";